import { render, staticRenderFns } from "./MyCheckDefaultResult.vue?vue&type=template&id=3cf40e10&"
import script from "./MyCheckDefaultResult.vue?vue&type=script&lang=js&"
export * from "./MyCheckDefaultResult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports